import React, { useMemo, useEffect, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useKurbanReportUIContext } from "../KurbanReportUIContext";
import { initialFilter, kurbanReportStatus } from "../KurbanReportUIHelpers"
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import History from "../../../../../../History";
import * as uiHelpers from '../KurbanReportUIHelpers';
import {
    Select,
} from '../../../../../../../_metronic/_partials/controls';
import { findArea, getLiveStock } from "../../_redux/report/kurbanReportCrud";
import { DatePickerField } from "../../../../../../../_metronic/_partials/controls";
import AsyncSelect from "react-select/async";
import { searchHewanKurban } from "../../../../_redux/hewan-kurban/hewanKurbanCrud";
import { promiseTuplify } from "../../../../../../../_metronic/_helpers/promiseUtils";
import { genOptionLoader } from "../../../../../../../_metronic/_helpers/fetchUtils";

const prepareFilter = (queryParams, values) => {
    const { kurban_hid, thk_area_uuid, thk_livestock_uuid, status, start_date, end_date } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    filter.status_includes = [uiHelpers.kurbanReportStatusKeys.REPORTED, uiHelpers.kurbanReportStatusKeys.FINISH];
    filter.kurban_hid = kurban_hid;
    filter.thk_area_uuid = thk_area_uuid;
    filter.thk_livestock_uuid = thk_livestock_uuid;
    filter.status = status;
    filter.start_date = start_date;
    filter.end_date = end_date;

    newQueryParams.filter = filter;
    return newQueryParams;
};

export function KurbanReportFilter({ listLoading }) {

    // KurbanReport UI Context
    const kurbanReportUIContext = useKurbanReportUIContext();
    const kurbanReportUIProps = useMemo(() => {
        return {
            setQueryParams: kurbanReportUIContext.setQueryParams,
            queryParams: kurbanReportUIContext.queryParams,
        };
    }, [kurbanReportUIContext]);

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(kurbanReportUIProps.queryParams, values);
        if (!isEqual(newQueryParams, kurbanReportUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            kurbanReportUIProps.setQueryParams(newQueryParams);
            History.push(uiHelpers.queryStringMaker(
                newQueryParams.filter.kurban_hid,
                newQueryParams.filter.thk_area_uuid,
                newQueryParams.filter.thk_livestock_uuid,
                newQueryParams.filter.status,
                newQueryParams.filter.start_date,
                newQueryParams.filter.end_date,
                newQueryParams.page,
                newQueryParams.sizePerPage,
                newQueryParams.sortField,
                newQueryParams.sortOrder)
            )
        }
    };

    const [livestockOptions, setLivestockOptions] = useState([]);
    
    useEffect(() => {
        (async () => {
            const [res] = await promiseTuplify(Promise.all([
                searchHewanKurban('type_not=17_SAPI')
            ]));

            const [livestockRes] = res ?? [];
            const {data: livestockData = {}} = livestockRes ?? {};
            const {data: {items: livestockItems = []}} = livestockData ?? {};

            setLivestockOptions(livestockItems.map(({uuid, name}) => ({label: name, value: uuid})));
        })();
    }, []);

    return (
        <Formik initialValues={initialFilter.filter}
            onSubmit={(values) => {
                applyFilter(values);
            }}
        >{({ values, handleSubmit, handleBlur, setFieldValue }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
                <div className="form-group row">
                    <div className="col-md-4 mb-3">
                        <input
                            type="text"
                            className="form-control"
                            name="kurban_hid"
                            placeholder="3220510007"
                            onBlur={handleBlur}
                            value={values.kurban_hid}
                            onChange={(e) => {
                                setFieldValue("kurban_hid", e.target.value);
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> No Kurban
                        </small>
                    </div>
                    <div className="col-md-4 mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="start_date"
                            onBlur={handleBlur}
                            value={values.start_date}
                            onChange={(e) => {
                                setFieldValue("start_date", e.target.value);
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> Tanggal Distribusi Dari
                        </small>
                    </div>
                    <div className="col-md-4 mb-3">
                        <input
                            type="date"
                            className="form-control"
                            name="end_date"
                            onBlur={handleBlur}
                            value={values.end_date}
                            onChange={(e) => {
                                setFieldValue("end_date", e.target.value);
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> Tanggal Distribusi Sampai
                        </small>
                    </div>
                    <div className="col-md-4 mb-3">
                        <AsyncSelect 
                            name="thk_livestock_uuid"
                            defaultOptions={livestockOptions}
                            loadOptions={genOptionLoader((query) => searchHewanKurban(`type_not=17_SAPI&${query}`), ({uuid, name}) => ({label: name, value: uuid}))}
                            value={values.thk_livestock ? {value: values.thk_livestock.value, label: values.thk_livestock.name} : {}}
                            onChange={({label, value}) => {
                                setFieldValue('thk_livestock_uuid', value);
                                setFieldValue('thk_livestock', {uuid: value, name: label});
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> Berdasarkan Hewan Kurban
                        </small>
                    </div>
                    <div className="col-md-4 mb-3">
                        <Select
                            name="status"
                            onBlur={handleBlur}
                            onChange={(e) => {
                                setFieldValue('status', e.target.value);
                            }}
                        >
                            <option value="">PILIH</option>
                            {
                                uiHelpers.kurbanReportReportedStatus.map((item) => {
                                    return <option key={item.value} value={item.value}>{item.text}</option>
                                })
                            }

                        </Select>
                        <small className="form-text text-muted">
                            <b>Cari</b> Berdasarkan Status
                        </small>
                    </div>
                </div>
                <button
                    type="submit"
                    onClick={() => handleSubmit()}
                    className="btn btn-primary btn-elevate float-right mb-20 ml-3"
                >
                    Cari
                </button>
            </form>
        )}
        </Formik>

    )
}
